'use client';
/* eslint-disable react/no-array-index-key */
/* eslint-disable tailwindcss/no-arbitrary-value */
import { MaterialIconName } from '@hyphengroup/cms-components/types/materialIconName';
import classNames from 'classnames';
import { MaterialIcon } from 'components/modulab/MaterialIcon';
import React from 'react';
import { BrandId } from 'utils/override';
import Button from './Button';
import ArrowRightAlt from './icons/ArrowRightAlt';
import { ComponentInsuranceStepper } from '$/(cms)/_modules/cmsService/types';
import { useClientContext } from '$/modules/context/client';

const bgColors: Record<BrandId, string> = {
  moneyhero: 'bg-white',
  singsaver: 'bg-white',
  moneymax: 'bg-fill/alternative-1',
  money101: 'bg-white',
};

export const InsuranceStepper: React.FC<ComponentInsuranceStepper> = ({
  title,
  subtitle,
  button_text,
  step,
}) => {
  const { brand } = useClientContext();
  const bgColor = bgColors[brand];
  // todo - implement onClick for opening modal window

  return (
    <div
      className={classNames(
        'g:gap-7 flex w-full flex-col items-start gap-4 px-padding/section-x py-padding/section-y md:items-center md:gap-6',
        bgColor,
      )}
    >
      <div className="flex flex-col gap-1 text-left md:text-center">
        <h2 className="mhg-alpha-typography-display-2 text-gray-900">
          {title}
        </h2>
        <p className="mhg-alpha-typography-body-1 text-gray-700">{subtitle}</p>
      </div>

      {/* Mobile layout */}
      <div className="flex w-full flex-col gap-6 md:hidden">
        {step?.map((item, index) => (
          <div
            className="flex w-full gap-4"
            key={`${item?.step_title}-${index}`}
          >
            <div className="flex flex-col items-center justify-between gap-6">
              <div className="flex size-10 min-h-10 min-w-10 flex-col items-center justify-center rounded-full bg-primary-800">
                {item?.icon && (
                  <MaterialIcon
                    icon={item.icon as MaterialIconName}
                    className="text-font-size/2xl"
                  />
                )}
              </div>
              {index !== step.length - 1 && (
                <div
                  className={classNames(
                    'max-h-8 min-h-8 w-0.5 min-w-0.5 bg-primary-200',
                    {
                      '!h-2.5 !min-h-2.5': index === 0 || !item?.step_subtitle,
                    },
                  )}
                ></div>
              )}
            </div>
            <div className="flex flex-col items-start gap-1">
              <span className="mhg-alpha-typography-title-2 text-left text-gray-900">
                {item?.step_title}
              </span>
              {item?.step_subtitle && (
                <span className="mhg-alpha-typography-body-2 text-left text-gray-600">
                  {item?.step_subtitle}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Desktop layout */}
      <div className="hidden w-full min-w-82 md:flex md:max-w-[720px] md:flex-col lg:max-w-[1010px] xl:max-w-[1170px] 2xl:max-w-screen-lg">
        <div className="flex w-full flex-row items-center justify-center gap-6 2xl:gap-8">
          {step?.map((item, index) => (
            <React.Fragment key={`icon-${index}`}>
              <div className="flex size-18 min-w-18 items-center justify-center rounded-full bg-primary-800 2xl:size-22 2xl:min-w-22">
                {item?.icon && (
                  <MaterialIcon
                    icon={item.icon as MaterialIconName}
                    className="text-font-size/5xl"
                  />
                )}
              </div>
              {index !== step.length - 1 && (
                <div className="size-0.5 h-4 min-h-4 w-[221.33px] min-w-0.5 bg-primary-200 md:ml-0 md:h-0.5 md:min-h-0.5 md:w-[66.67px] md:min-w-[66.67px] lg:w-[139.33px] lg:min-w-[139.33px] xl:w-[179.33px] xl:min-w-[179.33px] 2xl:w-[179.33px] 2xl:min-w-[179.33px]"></div>
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="mt-6 flex w-full flex-row justify-center gap-6">
          {step?.map((item, index) => (
            <div
              key={`text-${index}`}
              className="flex flex-1 flex-col items-center justify-start"
            >
              <div className="max-w-48 sm:max-w-48 md:max-w-[162px] md:flex-row lg:max-w-[235px] xl:max-w-[275px] 2xl:max-w-[322px]">
                <h3 className="mhg-alpha-typography-title-2 text-center text-gray-900">
                  {item?.step_title}
                </h3>
                {item?.step_subtitle && (
                  <p className="mhg-alpha-typography-body-2 text-center text-gray-600">
                    {item?.step_subtitle}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {button_text && (
        <div className="mt-6 flex w-full justify-center">
          <Button styleType="cta" endIcon={<ArrowRightAlt />}>
            {button_text}
          </Button>
        </div>
      )}
    </div>
  );
};
